<template>
  <GroupsItemParamValueDropdown
    v-if="isDropdownField"
    ref="inputRef"
    :comparison
    :fieldSettings
    :readonly
  />
  <GroupsItemParamValueDate v-else-if="isDateField" ref="inputRef" :readonly />
  <GroupsItemParamValueAmount v-else-if="isAmountField" ref="inputRef" :readonly />
  <GroupsItemParamValueInput v-else-if="isFieldVisible" ref="inputRef" :readonly />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { FilterComparison } from '../utils/enums'
import { FilterField } from '../utils/types'

import GroupsItemParamValueDate from './GroupsItemParamValueDate.vue'
import GroupsItemParamValueAmount from './GroupsItemParamValueAmount.vue'
import GroupsItemParamValueDropdown from './GroupsItemParamValueDropdown.vue'
import GroupsItemParamValueInput from './GroupsItemParamValueInput.vue'

type Props = {
  fieldSettings?: FilterField
  comparison?: FilterComparison
  readonly?: boolean
}

const props = defineProps<Props>()

defineExpose({
  start() {
    inputRef.value?.start()
  },
  initData() {
    inputRef.value?.init?.()
  },
})

const inputRef = ref<
  | typeof GroupsItemParamValueDate
  | typeof GroupsItemParamValueDropdown
  | typeof GroupsItemParamValueAmount
  | typeof GroupsItemParamValueInput
  | null
>(null)

const isDropdownField = computed(() => {
  if (!props.comparison || !props.fieldSettings) return false
  if (props.comparison === FilterComparison.LAST) return true
  if (
    (props.fieldSettings.list || props.fieldSettings.getter) &&
    [FilterComparison.EQ, FilterComparison.NOTEQ].includes(props.comparison)
  )
    return true
  return false
})

const isDateField = computed(() => {
  return isFieldVisible.value && props.fieldSettings?.isDate
})

const isAmountField = computed(() => {
  return isFieldVisible.value && props.fieldSettings?.isAmount
})

const isFieldVisible = computed(
  () =>
    props.comparison &&
    ![FilterComparison.EMPTY, FilterComparison.NOTEMPTY].includes(
      props.comparison,
    ),
)
</script>
